import React, { useState, useCallback, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import Axios from "../Utils/Axios";
import { AiOutlineMail, AiOutlineMobile, AiOutlineUser } from "react-icons/ai";
import { RiLockPasswordLine } from "react-icons/ri";
import Footer from "../Components/Footer";
import { toast, Slide } from "react-toastify";
import { ColorRing } from "react-loader-spinner";
import {
  LoginSocialGoogle,
  LoginSocialFacebook,
  IResolveParams,
} from "reactjs-social-login";
import { useDispatch, useSelector } from "react-redux";
import { loginSuccess, selectUserSettings } from "../store/authSlice";
import * as yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";
import { useForm, Controller } from "react-hook-form";
import PhoneInput, {
  isValidPhoneNumber,
  parsePhoneNumber,
} from "react-phone-number-input";
import "react-phone-number-input/style.css";
import { Helmet } from "react-helmet-async";
import { useUserCountry } from "../Utils/user-user-country";


const REDIRECT_URI = "https://limowide.com/login";

const LogoContent = (navigate: any) => {
  const userSettings = useSelector(selectUserSettings);

  return (
    <div>
      <p className="text-4xl font-bolder text-white">
        Welcome to {userSettings?.site_name}
      </p>
      <img
        src={userSettings?.site_logo}
        className="h-20 cursor-pointer"
        alt={userSettings?.site_name}
        onClick={() => navigate("/")}
      />
    </div>
  );
};

type SignupForm = {
  firstName: string;
  lastName: string;
  email: string;
  password: string;
  confirmPassword: string;
  mobile: string;
};
const signupschema = yup.object().shape({
  firstName: yup
    .string()
    .required("First Name is required")
    .max(20, "First Name must be at most 5 characters"),
  lastName: yup
    .string()
    .required("Last Name is required")
    .max(20, "Last Name must be at most 5 characters"),
  email: yup
    .string()
    .email("Enter Valid Mail Address")
    .required("Email is required")
    .max(100),
  password: yup
    .string()
    .required("Password is required")
    .min(8, "Password must be at least 8 characters")
    .max(20, "Password must be at most 20 characters"),
  confirmPassword: yup
    .string()
    .required("Confirm Password is required")
    .max(20)
    .oneOf([yup.ref("password")], "Password and Confirm Password must match"),
  mobile: yup
    .string()
    .test("is-valid-phone-number", "Invalid phone number", (value) => {
      if (!value) {
        return true;
      }
      return isValidPhoneNumber(value);
    })
    .required("Mobile Number is required"),
});
const Signup = (props: any) => {
  const navigate: any = useNavigate();
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [terms, setacceptTerms] = useState<boolean>(false);
  const [error, setError] = useState<any>(null);
  const [signupLoading, setSignupLoading] = useState<boolean>(false);
  const [provider, setProvider] = useState("");
  const [profile, setProfile] = useState<any>();
  const dispatch = useDispatch();
  const userCountry = useUserCountry();
  const {
    control,
    handleSubmit,
    formState: { errors },
    setValue,
  } = useForm<SignupForm>({
    resolver: yupResolver(signupschema),
    defaultValues: { mobile: userCountry?.dial_code ?? "+" },
  });

  // useEffect(() => {
  //   setValue("mobile", userCountry?.dial_code ?? "");
  // }, [userCountry?.dial_code]);

  const onSubmit: any = async (data: any) => {
    const phoneNumber = parsePhoneNumber(data.mobile);
    if (!terms) {
      setError("Please accept the terms");
      return;
    }
    setSignupLoading(true);
    try {
      setIsLoading(true);
      const payload = {
        first_name: data.firstName,
        last_name: data.lastName,
        phone: phoneNumber?.nationalNumber,
        isd_code: phoneNumber?.countryCallingCode,
        email: data.email,
        password: data.password,
        confirm_password: data.confirmPassword,
      };

      const config: any = {
        method: "POST",
        url: "/api/v1/sign-up/",
        data: payload,
      };
      const signupRes: any = await Axios(config).catch((e: any) => {
        if (e.response.data.data.email) {
          setError(e.response.data.data.email);
        } else if (e.response.data.data.phone) {
          setError(e.response.data.data.phone);
        }
        setSignupLoading(false);
        setIsLoading(false);
      });
      if (signupRes?.data?.detail) {
        toast.success("Please Check your email to verify your account.", {
          position: "top-center",
          autoClose: 3000,
          closeOnClick: true,
          transition: Slide,
        });
        setIsLoading(false);
        navigate("/login");
      }
    } catch (err: any) {
      console.log("catch data:-", err);
      setSignupLoading(false);
      setIsLoading(false);
    }
  };

  const onLogoutSuccess = useCallback(() => {
    setProfile(null);
    setProvider("");
  }, []);
  const onLoginSuccess = useCallback(
    async ({ provider, data }: IResolveParams) => {
      setProfile(null);
      setProvider(provider);
      const payload = {
        provider: provider,
        access_token: data?.access_token,
        first_name: data?.given_name,
        last_name: data?.family_name,
      };
      const config: any = {
        method: "POST",
        url: "/api/v1/socail/login/",
        data: payload,
      };
      const loginRes: any = await Axios(config).catch((e: any) => {
        setIsLoading(false);
        setError(
          e?.response?.data?.data?.email || e?.response?.data?.data?.password
        );
      });
      if (loginRes?.data?.token?.access_token) {
        setError(null);
        Axios.defaults.headers.common[
          "Authorization"
        ] = `Bearer ${loginRes?.data?.token?.access_token}`;
        dispatch(loginSuccess(loginRes?.data));
        navigate("/");
      }
    },
    []
  );

  const userSettings = useSelector(selectUserSettings);

  return (
    <div className="h-screen bg-gray-800 grid grid-cols-2">
      <Helmet>
        <title>Signup</title>
      </Helmet>
      <div className="lg:flex hidden flex-col justify-center items-center p-4 text-center bg-gray-800 ">
        <p className="text-4xl font-bolder text-white">
          Welcome to {userSettings?.site_name}
        </p>
        <img
          src={userSettings?.site_logo}
          className="h-20 cursor-pointer"
          alt={userSettings?.site_name}
          onClick={() => navigate("/")}
        />
      </div>
      <div className="col-span-2 lg:col-span-1 flex flex-col justify-center items-center text-center p-4 bg-gray-800">
        <div className="flex-col flex justify-center items-center text-center lg:hidden">
          {LogoContent(navigate)}
        </div>
        <form onSubmit={handleSubmit(onSubmit)}>
          <div className="bg-white px-6 py-8 rounded-xl mt-6 w-full">
            <p className="text-3xl font-bold">Signup</p>
            <div className="py-2 flex mt-4">
              <AiOutlineUser className="w-10 h-10 mr-3" />
              <Controller
                name="firstName"
                control={control}
                defaultValue=""
                rules={{ required: "First Name is Required" }}
                render={({ field }) => (
                  <input
                    {...field}
                    type="text"
                    name="firstName"
                    placeholder="First Name *"
                    className={
                      "py-2 pl-5 w-40 border-b-2 focus:outline-0 focus:shadow-lg " +
                      (errors.firstName ? "border-red-700" : "border-blue-400")
                    }
                  />
                )}
              />
              <Controller
                name="lastName"
                control={control}
                defaultValue=""
                rules={{ required: "Last Name is Required" }}
                render={({ field }) => (
                  <input
                    {...field}
                    type="text"
                    name="lastName"
                    placeholder="Last Name *"
                    className={
                      "py-2 ml-2 pl-3 w-40 border-b-2 focus:outline-0 focus:shadow-lg " +
                      (errors.lastName ? "border-red-700" : "border-blue-400")
                    }
                  />
                )}
              />
            </div>
            {errors && (errors.firstName || errors.lastName) && (
              <div className="py-2">
                <div className="mx-4 capitalize text-red-500 w-full">
                  {errors.firstName?.message}&nbsp; &nbsp;
                  {errors.lastName?.message}
                </div>
              </div>
            )}
            <div className="py-2 flex">
              <AiOutlineMail className="w-10 h-10 mr-3" />
              <Controller
                name="email"
                control={control}
                defaultValue=""
                rules={{ required: true }}
                render={({ field }) => (
                  <input
                    {...field}
                    type="email"
                    autoComplete="username"
                    name="email"
                    placeholder="Email *"
                    className={
                      "py-2  pl-5 w-80 border-b-2 focus:outline-0 focus:shadow-lg " +
                      (errors.email ? "border-red-700" : "border-blue-400")
                    }
                  />
                )}
              />
            </div>
            {errors.email && (
              <div className="py-3">
                <div className="capitalize text-red-500 w-80">
                  {errors.email?.message}
                </div>
              </div>
            )}
            <div className="py-2 flex" id="signupphone">
              <AiOutlineMobile className="w-10 h-10 mr-3" />
              <Controller
                name="mobile"
                control={control}
                rules={{ validate: (value) => isValidPhoneNumber(value) }}
                defaultValue={userCountry?.dial_code}
                render={({ field }) => (
                  <PhoneInput
                    placeholder="Mobile Number"
                    value={field.value}
                    onChange={(value) =>
                      value ? field.onChange(value) : field.onChange("")
                    }
                    error={errors.mobile?.message}
                  />
                )}
              />
            </div>

            {errors.mobile && (
              <div className="py-2">
                <div className="capitalize text-red-500 w-80">
                  {errors.mobile.message}
                </div>
              </div>
            )}
            <div className="py-2 flex">
              <RiLockPasswordLine className="w-10 h-10 mr-3" />
              <Controller
                name="password"
                control={control}
                defaultValue=""
                rules={{ required: true }}
                render={({ field }) => (
                  <input
                    type="password"
                    {...field}
                    placeholder="Password e.g. Qwerty@1"
                    autoComplete="new-password"
                    className={
                      "py-2  pl-5 w-80 border-b-2 focus:outline-0 focus:shadow-lg " +
                      (errors.password ? "border-red-700" : "border-blue-400")
                    }
                  />
                )}
              />
            </div>
            {errors.password && (
              <div className="py-2">
                <div className="capitalize text-red-500 w-80">
                  {errors.password?.message}
                </div>
              </div>
            )}
            <div className="py-2 flex">
              <RiLockPasswordLine className="w-10 h-10 mr-3" />
              <Controller
                name="confirmPassword"
                control={control}
                defaultValue=""
                rules={{ required: true }}
                render={({ field }) => (
                  <input
                    type="password"
                    {...field}
                    placeholder="Password e.g. Qwerty@1"
                    autoComplete="new-password"
                    className={
                      "py-2  pl-5 w-80 border-b-2 focus:outline-0 focus:shadow-lg " +
                      (errors.confirmPassword
                        ? "border-red-700"
                        : "border-blue-400")
                    }
                  />
                )}
              />
            </div>
            {errors.confirmPassword && (
              <div className="py-2">
                <div className="capitalize text-red-500 w-80">
                  {errors.confirmPassword?.message}
                </div>
              </div>
            )}
            <div className="mt-5">
              <div className="flex" style={{ width: "25rem" }}>
                <div>
                  <input
                    type="checkbox"
                    name="terms"
                    id="terms"
                    onChange={() => setacceptTerms(!terms)}
                    className=" form-checkbox  rounded    border-gray-300
                        text-indigo-600
                        shadow-sm
                        focus:border-indigo-300
                        focus:ring
                        focus:ring-offset-0
                        focus:ring-indigo-200
                        focus:ring-opacity-50
                      "
                  />
                </div>
                <div className="w-full pl-2">
                  <p className="text-left">
                    <label>
                      I have read and agree to the Privacy Policy and the Cookie
                      Notice. OurTerms & Conditions apply.
                    </label>
                  </p>
                </div>
              </div>
            </div>
            {error && (
              <div>
                <p className="capitalize text-red-500 mt-4">{error}</p>
              </div>
            )}
            {isLoading ? (
              <ColorRing
                visible={true}
                height="80"
                width="80"
                ariaLabel="blocks-loading"
                wrapperStyle={{ float: "right", marginRight: "40%" }}
                wrapperClass="blocks-wrapper"
                colors={["#b8c480", "#B2A3B5", "#F4442E", "#51E5FF", "#429EA6"]}
              />
            ) : (
              <input
                className="w-full block mt-6 bg-gradient-to-r bg-gray-800  px-10 py-4 rounded-lg text-white text-lg font-bold hover:bg-yellow-600"
                type="submit"
                value="Sign Up"
              />
            )}
            <button
              onClick={() => navigate("/login")}
              className="w-full mt-6 rounded-lg bg-gray-600 px-10 py-4 text-white font-bold"
            >
              Login
            </button>
            <div className="my-4 flex items-center before:mt-0.5 before:flex-1 before:border-t before:border-neutral-300 after:mt-0.5 after:flex-1 after:border-t after:border-neutral-300">
              <p className="mx-4 mb-0 text-center font-semibold dark:text-white">
                Or
              </p>
            </div>
            <div className="flex justify-around">
              <p className="m-2 mb-0 text-lg">Sign in with</p>
              <LoginSocialGoogle
                client_id="207724466343-7ubs3lrb7208q2s6evjsh5tlb19s3jt2.apps.googleusercontent.com"
                redirect_uri={REDIRECT_URI}
                scope="openid profile email"
                discoveryDocs="claims_supported"
                access_type="offline"
                onResolve={onLoginSuccess}
                onReject={(err) => {
                  console.log(err);
                }}
              >
                <button
                  type="button"
                  data-te-ripple-init
                  data-te-ripple-color="light"
                  className="inline-block rounded-full bg-primary p-2 uppercase leading-normal text-white shadow-[0_4px_9px_-4px_#3b71ca] transition duration-150 ease-in-out hover:bg-primary-600 hover:shadow-[0_8px_9px_-4px_rgba(59,113,202,0.3),0_4px_18px_0_rgba(59,113,202,0.2)] focus:bg-primary-600 focus:shadow-[0_8px_9px_-4px_rgba(59,113,202,0.3),0_4px_18px_0_rgba(59,113,202,0.2)] focus:outline-none focus:ring-0 active:bg-primary-700 active:shadow-[0_8px_9px_-4px_rgba(59,113,202,0.3),0_4px_18px_0_rgba(59,113,202,0.2)] dark:shadow-[0_4px_9px_-4px_rgba(59,113,202,0.5)] dark:hover:shadow-[0_8px_9px_-4px_rgba(59,113,202,0.2),0_4px_18px_0_rgba(59,113,202,0.1)] dark:focus:shadow-[0_8px_9px_-4px_rgba(59,113,202,0.2),0_4px_18px_0_rgba(59,113,202,0.1)] dark:active:shadow-[0_8px_9px_-4px_rgba(59,113,202,0.2),0_4px_18px_0_rgba(59,113,202,0.1)]"
                >
                  <svg
                    width="35px"
                    height="35px"
                    viewBox="0 0 32 32"
                    data-name="Layer 1"
                    id="Layer_1"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M23.75,16A7.7446,7.7446,0,0,1,8.7177,18.6259L4.2849,22.1721A13.244,13.244,0,0,0,29.25,16"
                      fill="#00ac47"
                    />
                    <path
                      d="M23.75,16a7.7387,7.7387,0,0,1-3.2516,6.2987l4.3824,3.5059A13.2042,13.2042,0,0,0,29.25,16"
                      fill="#4285f4"
                    />
                    <path
                      d="M8.25,16a7.698,7.698,0,0,1,.4677-2.6259L4.2849,9.8279a13.177,13.177,0,0,0,0,12.3442l4.4328-3.5462A7.698,7.698,0,0,1,8.25,16Z"
                      fill="#ffba00"
                    />
                    <polygon
                      fill="#2ab2db"
                      points="8.718 13.374 8.718 13.374 8.718 13.374 8.718 13.374"
                    />
                    <path
                      d="M16,8.25a7.699,7.699,0,0,1,4.558,1.4958l4.06-3.7893A13.2152,13.2152,0,0,0,4.2849,9.8279l4.4328,3.5462A7.756,7.756,0,0,1,16,8.25Z"
                      fill="#ea4435"
                    />
                    <polygon
                      fill="#2ab2db"
                      points="8.718 18.626 8.718 18.626 8.718 18.626 8.718 18.626"
                    />
                    <path
                      d="M29.25,15v1L27,19.5H16.5V14H28.25A1,1,0,0,1,29.25,15Z"
                      fill="#4285f4"
                    />
                  </svg>
                </button>
              </LoginSocialGoogle>
              <LoginSocialFacebook
                appId="1226842592047274"
                fieldsProfile={
                  "id,first_name,last_name,middle_name,name,name_format,picture,short_name,email,gender"
                }
                onLogoutSuccess={onLogoutSuccess}
                redirect_uri={REDIRECT_URI}
                onResolve={({ provider, data }: IResolveParams) => {
                  setProvider(provider);
                  setProfile(data);
                }}
                onReject={(err) => {
                  console.log(err);
                }}
              >
                <button
                  type="button"
                  data-te-ripple-init
                  data-te-ripple-color="light"
                  className="inline-block rounded-full bg-primary p-2 uppercase leading-normal text-white shadow-[0_4px_9px_-4px_#3b71ca] transition duration-150 ease-in-out hover:bg-primary-600 hover:shadow-[0_8px_9px_-4px_rgba(59,113,202,0.3),0_4px_18px_0_rgba(59,113,202,0.2)] focus:bg-primary-600 focus:shadow-[0_8px_9px_-4px_rgba(59,113,202,0.3),0_4px_18px_0_rgba(59,113,202,0.2)] focus:outline-none focus:ring-0 active:bg-primary-700 active:shadow-[0_8px_9px_-4px_rgba(59,113,202,0.3),0_4px_18px_0_rgba(59,113,202,0.2)] dark:shadow-[0_4px_9px_-4px_rgba(59,113,202,0.5)] dark:hover:shadow-[0_8px_9px_-4px_rgba(59,113,202,0.2),0_4px_18px_0_rgba(59,113,202,0.1)] dark:focus:shadow-[0_8px_9px_-4px_rgba(59,113,202,0.2),0_4px_18px_0_rgba(59,113,202,0.1)] dark:active:shadow-[0_8px_9px_-4px_rgba(59,113,202,0.2),0_4px_18px_0_rgba(59,113,202,0.1)]"
                >
                  <svg
                    width="40px"
                    height="40px"
                    viewBox="126.445 2.281 589 589"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <circle
                      cx={420.945}
                      cy={296.781}
                      r={294.5}
                      fill="#3c5a9a"
                    />
                    <path
                      d="M516.704 92.677h-65.239c-38.715 0-81.777 16.283-81.777 72.402.189 19.554 0 38.281 0 59.357H324.9v71.271h46.174v205.177h84.847V294.353h56.002l5.067-70.117h-62.531s.14-31.191 0-40.249c0-22.177 23.076-20.907 24.464-20.907 10.981 0 32.332.032 37.813 0V92.677h-.032z"
                      fill="#ffffff"
                    />
                  </svg>
                </button>
              </LoginSocialFacebook>
            </div>
          </div>
        </form>
      </div>
      <div className="bg-gray-800 w-full col-span-2">
        <Footer />
      </div>
    </div>
  );
};

export default Signup;
